import { faHeartPulse, faUserGroup } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Form, Row, Card } from 'antd'
import React, { useEffect } from 'react'
import MedicalHistoryFormTemplates from '../../utils/templates'
import DesktopMedicalHistoryNav from './Nav'
import useFamilyHistory from '../../hooks/useFamilyHistory'
import '../style/DesktopFamilyHistory.css'
import DesktopSectionHeader from './DesktopSectionHeader'

const DesktopFamilyHistory = ({ clientForm, setFacet, setSaving }) => {
  const { handleOptionClick, handleSubmit, selectedConditions } = useFamilyHistory({ clientForm, setFacet, setSaving })

  // Scroll to top when component mounts
  useEffect(() => {
    setTimeout(() => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 0)
  }, [])

  return (
    <div className='desktop-family-history-container'>
      <DesktopSectionHeader
        icon={faUserGroup}
        title='Family History'
        subtitle='Do any of your immediate family members have these conditions?'
      />

      <div className='desktop-family-history-content'>
        <Card className='desktop-conditions-card'>
          <Row gutter={[16, 16]}>
            {MedicalHistoryFormTemplates.dataModel.familyHistoryList.options.map((condition, index) => {
              const isSelected = selectedConditions.includes(condition.value)

              return (
                <Col xs={24} sm={12} md={8} lg={6} key={condition.value}>
                  <div
                    className={`desktop-condition-option ${isSelected ? 'selected' : ''}`}
                    role='checkbox'
                    onClick={() => handleOptionClick(condition)}
                    aria-checked={isSelected}
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handleOptionClick(condition)
                      }
                    }}
                  >
                    <div className='desktop-condition-icon'>
                      <FontAwesomeIcon icon={faHeartPulse} />
                    </div>
                    <span className='desktop-condition-name'>{condition.label}</span>

                    <Form.Item name={['familyHistory', 'list']} style={{ display: 'none' }}>
                      <input type='checkbox' />
                    </Form.Item>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Card>
      </div>

      <DesktopMedicalHistoryNav
        prevFunction={() => {
          clientForm.resetFields()
          setFacet(null)
        }}
        nextFunction={handleSubmit}
        prevText='Back to Overview'
        nextText='Save Family History'
      />
    </div>
  )
}

export default DesktopFamilyHistory
